import { gql } from 'apollo-angular'

export const REJECT_ORGANIZATION_RESELLER_REQUEST = gql`
  mutation RejectOrganizationResellerRequest(
    $data: RejectOrganizationResellerRequestInput!
  ) {
    rejectOrganizationResellerRequest(data: $data) {
      success
    }
  }
`
